import { Box, Typography } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  FEATURE_FLAGS,
  useFeatureFlag,
} from '../../../../../../lib/featureFlags';
import { StudyPreparationChat } from '../../../../../../pages/interpretiveReports/studyPreparation/StudyPreparationChat';
import { latestSampleSetInterpretiveReportQueryOptions } from '../../../../../../services/queries';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/'
)({
  loader: async ({ context, params }) => {
    const latestReport = await context.queryClient.fetchQuery(
      latestSampleSetInterpretiveReportQueryOptions(
        params.sampleSetId,
        context.auth.hasPermission
      )
    );

    if (latestReport) {
      throw redirect({
        to: '/experiments/$sampleSetId/interpretations/$interpretationId',
        params: {
          sampleSetId: params.sampleSetId,
          interpretationId: latestReport.id,
        },
        search: true,
        replace: true,
      });
    }
  },
  // Renders only when the user can see no interpretation of the sample set
  component: NoInterpretationRoute,
});

function NoInterpretationRoute() {
  const { sampleSetId } = Route.useParams();
  const studyPreparationChatEnabled = useFeatureFlag(
    FEATURE_FLAGS.studyPreparationChat
  );

  if (studyPreparationChatEnabled) {
    // Keyed by sample set: each set has its own conversation, and another
    // set's route keeps this component mounted.
    return <StudyPreparationChat key={sampleSetId} sampleSetId={sampleSetId} />;
  }
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200,
      }}
    >
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        No interpretations for this sample set yet.
      </Typography>
    </Box>
  );
}
